module.exports = "/_next/static/images/2ab9f2309ce28e355300f116d33a0dec-kit-ui.png";